import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import 'gw-capability-quoteandbind-PremierCL-react';
import 'gw-capability-policychange-common-react';
import 'premier-capability-policychange-common-react';
import CLPolicyChangesPage from './pages/CLPolicyChanges/CLPolicyChangesPage';

setComponentMapOverrides(
    {
        PremierCLPolicyChangesPage: { component: 'PremierCLPolicyChangesPage' }
    },
    {
        PremierCLPolicyChangesPage: CLPolicyChangesPage
    }
);

export { default as PremierCLPolicyChangeWizard } from './PremierCLPolicyChangeWizard';
